import GateStepper from './GateStepper';

export default GateStepper;

export type { GateStepperVariant, IGate, IGateStepperProps } from './GateStepper';
